<template>
  <aside
    class="contest-menu"
    :class="{ 'contest-menu--visible': visible }"
    @click="$emit('hide')"
  >
    <div class="contest-menu__overlay"/>
    <ul class="contest-menu__list">
      <li class="contest-menu__item">
        <router-link class="contest-menu__link" :to="{ name: 'map' }">
          Wróć do mapy
        </router-link>
      </li>

      <li class="contest-menu__item">
        <router-link class="contest-menu__link" :to="{ name: 'contest-prizes' }">
          Nagrody
        </router-link>
      </li>

      <li class="contest-menu__item">
        <router-link class="contest-menu__link" :to="{ name: 'contest' }">
          Zasady
        </router-link>
      </li>

      <li class="contest-menu__item">
        <a class="contest-menu__link" target="_blank" href="/Regulamin_Konkursu_To_miasto.pdf">
          Regulamin
        </a>
      </li>

      <li class="contest-menu__item" v-if="false">
        <a class="contest-menu__link" href="#laureaci">
          Laureaci
        </a>
      </li>
    </ul>
  </aside>
</template>

<script>
export default {
  props: {
    visible: {
      type: Boolean,
      default: false
    }
  }
}
</script>

<style lang="scss" scoped>
  .contest-menu {
    @include full-size(fixed);
    @include center;
    background-color: darken(#c51414, 4%);

    left: auto;
    right: 0;
    max-width: 480px;
    z-index: z(submit-map) + 1;

    transform: translate3d(100%, 0, 0);
    pointer-events: none;
    transition: transform $base-transition,
                box-shadow $base-transition;

    &--visible {
      transform: translate3d(0, 0, 0);
      pointer-events: auto;
      box-shadow: -27px 18px 46.239999999999995px 21.76px rgba(0, 0, 0, 0.33);
    }

    &__list {
      @include reset-list;
      text-align: center;
    }

    &__item {
      font-size: 24px;

      @include media-up(md) {
        font-size: 34px;
      }

      &:not(:last-child) {
        margin-bottom: 1em;
      }
    }

    &__link {
      @include font($akrobat-font, 900)
      @include reset-link;
      text-transform: uppercase;
      letter-spacing: .05em;
      transition: opacity $base-transition;

      &:hover {
        opacity: .8;
      }
    }

    &__overlay {
      @include full-size;
      mix-blend-mode: screen;
      background-image: url('/img/noise-pattern-alpha.png');
      pointer-events: none;
    }
  }
</style>



// WEBPACK FOOTER //
// src/containers/ContestMenu/ContestMenu.vue